import React from 'react'
const References = () => {
  return (
    <div name='references' className='w-full  text-gray-300 bg-[#0a192f]'>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
            References
          </p>
          <div  className='h-12' >

          </div>
         
          <div className='flex flex-row items-center  md:flex-row '>
          <p className='text-2xl font-semibold inline mr-12 text-gray-300'>
            Berkant Cen
          </p>
          <p className='py-6'>Frontend developer at BtcTurk </p>
         
          </div>

          <div className='flex flex-row items-center  md:flex-row '>
          <p className='text-2xl font-semibold inline mr-12 text-gray-300'>
            Anna Atalay
          </p>
          <p className='py-6'>Co-Founder at Code2Career</p>
         
          </div>
          </div>

        
          </div>
          </div>
  )
}

export default References